import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { CacheGetItem, CacheSetItem, LEGACY_COOKIE_KEYS, STORAGE_KEYS, StorageRemoveItem } from "../admin/components/StorageComp";

const WebsiteContext = createContext(null);

export const WebsiteProvider = ({ children }) => {
    const [currentDomain, setCurrentDomain] = useState('');
    const [websiteData, setWebsiteData] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchWebsite = async (domain) => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL + "v1/website/website-by-domain",
                {
                    params: { domain },
                }
            );

            const data = response.data.data || null;

            setWebsiteData(data);

            if (data) {
                CacheSetItem(STORAGE_KEYS.WEBSITE, data, 15 * 60 * 1000);
            }

            return data;
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        const loadWebsite = async () => {
            try {
                let domain = window.location.hostname;

                if (window.location.port) {
                    domain += ":" + window.location.port;
                }

                setCurrentDomain(domain);

                // clear cookies from before the key rename (website data in cookies
                // was too large and got dropped by Safari)
                LEGACY_COOKIE_KEYS.forEach((key) => StorageRemoveItem(key));

                // main domain -> no website config needed
                if (domain === process.env.REACT_APP_BASE_DOMAIN) {
                    setLoading(false);
                    return;
                }

                const cache = CacheGetItem(STORAGE_KEYS.WEBSITE);

                // show cached data immediately, then refresh it in the background
                if (cache?.domain === domain) {
                    setWebsiteData(cache);
                    setLoading(false);
                }

                await fetchWebsite(domain);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        loadWebsite();
    }, []);

    return (
        <WebsiteContext.Provider
            value={{
                websiteData,
                setWebsiteData,
                currentDomain,
                setCurrentDomain,
                loading,
                refreshWebsite: fetchWebsite,
            }}
        >
            {children}
        </WebsiteContext.Provider>
    );
};

export const useWebsite = () => {
    return useContext(WebsiteContext);
};